import React from 'react'
import { Fade } from 'react-reveal'
import { NavLink } from 'react-router-dom'
import { formatRoute } from 'react-router-named-routes'

const Item = ({ item, index, selectedCompany, checkIncentivesTaxIdValidity, locale, checkTaxServiceLink, openMenuItemDialog }) => {
  const matchConditionDialog = (menuItem) => {
    const conditions = menuItem?.conditionDialog?.conditions || []
    return conditions.find(c => !!c.condition) || null
  }

  return (
    <Fade bottom delay={index * 100} key={item.key}>
     {!item.hide && <li>
        {!!item.isIncentive
          ? (!item.hide && (!!matchConditionDialog(item)
              ? <button rel="noopener noreferrer" onClick={() => openMenuItemDialog(matchConditionDialog(item).messageId)}>{item.label}</button>
              : <button rel="noopener noreferrer" onClick={() => checkIncentivesTaxIdValidity(selectedCompany?.tax_id)}>{item.label}</button>))
          : (!!item?.isTaxService ?
            <button rel="noopener noreferrer"
                    onClick={() => checkTaxServiceLink(item.link + (!!item.isSAP ? `&sap-language=${locale}` : ''))}>{item.label}</button>
            : (!!matchConditionDialog(item) ?
              <button rel="noopener noreferrer"
                      onClick={() => openMenuItemDialog(matchConditionDialog(item).messageId)}>{item.label}</button>
              : (!!item.target
                ? <a href={item.link} target='_blank' rel="noopener noreferrer">{item.label}</a>
                : (!!item.noLink
                  ? <button rel="noopener noreferrer">{item.label}</button>
                  : <NavLink exact activeClassName="active"
                             to={(!!selectedCompany?.id) ? formatRoute(item.link, { id: selectedCompany.id }) : item.link}>
                    {item.label}
                  </NavLink>))))
        }
        {!!item.subMenu && !!item.subMenu.length && (item.subMenu.length > item.subMenu?.filter(sub => !!sub.isUPTCP)?.length || (!!selectedCompany?.user_uptcp_enrollment_eligibility &&
          !!selectedCompany?.user_uptcp_enrolled_at)) &&
        <ul>
          {item.subMenu.map((subItem) => (
            !subItem.hide && 
            (!!subItem.isUPTCP ? (!!selectedCompany?.user_uptcp_enrollment_eligibility &&
                !!selectedCompany?.user_uptcp_enrolled_at &&
                <li key={subItem.key}>
                  {!!matchConditionDialog(subItem)
                    ? <button rel="noopener noreferrer" onClick={() => openMenuItemDialog(matchConditionDialog(subItem).messageId)}>{subItem.label}</button>
                    : <a href={subItem.link} target='_blank' rel="noopener noreferrer">{subItem.label}</a>
                  }
                </li>) :
                <li key={subItem.key}>
                  {!!subItem.isIncentive
                    ? (!subItem.hide && (!!matchConditionDialog(subItem)
                        ? <button rel="noopener noreferrer" onClick={() => openMenuItemDialog(matchConditionDialog(subItem).messageId)}>{subItem.label}</button>
                        : <button rel="noopener noreferrer" onClick={() => checkIncentivesTaxIdValidity(selectedCompany?.tax_id)}>{subItem.label}</button>))
                    : (!!subItem?.isTaxService ?
                      <button rel="noopener noreferrer"
                              onClick={() => checkTaxServiceLink(subItem.link + (!!subItem.isSAP ? `&sap-language=${locale}` : ''))}>{subItem.label}</button>
                      : (!!matchConditionDialog(subItem) ?
                        <button rel="noopener noreferrer"
                                onClick={() => openMenuItemDialog(matchConditionDialog(subItem).messageId)}>{subItem.label}</button>
                        : (!!subItem.target
                          ? <a href={subItem.link} target='_blank' rel="noopener noreferrer">{subItem.label}</a>
                          : (!!subItem.noLink
                            ? <button rel="noopener noreferrer">{subItem.label}</button>
                            : <NavLink exact activeClassName="active"
                                       to={(!!selectedCompany?.id) ? formatRoute(subItem.link, { id: selectedCompany.id }) : subItem.link}>
                              {subItem.label}
                            </NavLink>))))
                  }
                </li>
            )))}
        </ul>
        }
      </li>}
    </Fade>
  )
}

export default Item
